import { academySlice } from "./academyReducer";
import { call, put, select, takeEvery, takeLeading } from "redux-saga/effects";
import { getIsAcademyEnabledSelector, getIsAcademyInitedSelector } from "./academySelectors";
import { getRequest } from "../../app/request";
import { IAcademyLessonStep, ICompleteAcademyStepSuccessActionPayload, ILoadAcademyInfoResponse } from "./academy.t";
import { failurePut } from "../../app/failurePut";
import { notificationsSlice } from "../Notifications/notificationsReducer";
import {
    NOTIFICATION_MESSAGE_ACADEMY_EVENTS,
    NOTIFICATIONS_MESSAGE_TYPES
} from "../Notifications/notificationsConstants";

function* initAcademySaga() {
    const isInited = yield select(getIsAcademyInitedSelector);
    if (isInited) return;
    yield put(academySlice.actions.initAcademySuccessAction());

    const isAcademyEnabled = yield select(getIsAcademyEnabledSelector);
    if (!isAcademyEnabled) return;

    yield put(academySlice.actions.loadAcademyInfoAction());
}

function* loadAcademyInfoSaga() {
    try {
        const data: ILoadAcademyInfoResponse = yield call(getRequest, '/academy');
        yield put(academySlice.actions.loadAcademyInfoSuccessAction(data));
    } catch (e) {
        yield call(failurePut, e, academySlice.actions.loadAcademyInfoFailureAction);
    }
}

function* loadAcademyLessonStepsSaga({ payload }: ReturnType<typeof academySlice.actions.loadAcademyLessonStepsAction>) {
    try {
        const data: IAcademyLessonStep[] = yield call(getRequest, `/academy/lesson/${payload}/steps`);
        yield put(academySlice.actions.loadAcademyLessonStepsSuccessAction(data));
    } catch (e) {
        yield call(failurePut, e, academySlice.actions.loadAcademyLessonStepsFailureAction);
    }
}

function* completeAcademyLessonStepSaga({ payload }: ReturnType<typeof academySlice.actions.completeAcademyLessonStepAction>) {
    const { answerStepKey, isLessonLastStep, lastCompletedStepKey, lessonKey } = payload;

    const params: ICompleteAcademyStepSuccessActionPayload = {
        answerStepKey,
        isLessonLastStep,
        lastCompletedStepKey,
        lessonKey,
    }
    yield put(notificationsSlice.actions.sendNotificationMessageAction({
        type: NOTIFICATIONS_MESSAGE_TYPES.ACADEMY,
        params: {
            event: NOTIFICATION_MESSAGE_ACADEMY_EVENTS.STEP_COMPLETED,
            payload: params,
        }
    }));

    yield put(academySlice.actions.completeAcademyLessonStepSuccessAction(params));
}

function* updateAcademyLessonSaga({ payload }: ReturnType<typeof academySlice.actions.updateUserAcademyLessonAction>) {
    yield put(notificationsSlice.actions.sendNotificationMessageAction({
        type: NOTIFICATIONS_MESSAGE_TYPES.ACADEMY,
        params: {
            event: NOTIFICATION_MESSAGE_ACADEMY_EVENTS.UPDATE_USER_ACADEMY_LESSON,
            payload,
        }
    }));
}

export function* academySagas() {
    yield takeLeading(academySlice.actions.initAcademyAction, initAcademySaga);
    yield takeEvery(academySlice.actions.loadAcademyInfoAction, loadAcademyInfoSaga);
    yield takeEvery(academySlice.actions.loadAcademyLessonStepsAction, loadAcademyLessonStepsSaga);
    yield takeEvery(academySlice.actions.completeAcademyLessonStepAction, completeAcademyLessonStepSaga);
    yield takeEvery(academySlice.actions.updateUserAcademyLessonAction, updateAcademyLessonSaga);
}
